import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Figure from './Figure';

/**
 * FiguresTable
 */

class FiguresTable extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.play = () => {
      this.setState({ isPlaying: true });
      this.figures.forEach((figure, index) => {
        setTimeout(() => {
          figure.current.play();
        }, index * 350);
      });
    };
    this.paused = () => !this.state.isPlaying;

    /** State */
    this.state = { isPlaying: this.props.play };

    /** Refs */
    this.figures = this.props.figures.map(() => React.createRef());
  }

  render() {
    const elementClass = this.props.dots ? 'l-dots' : '';
    const columnCount = this.props.columns || 2;
    return (
      <ul className={`figures-table ${elementClass} table-${columnCount}-col`}>
        {this.props.figures.map((figure, index) => (
          <li key={index}>
            {figure.title && <strong className={`figures-table-title text-${figure.color}`}>{figure.title}</strong>}
            <Figure
              ref={this.figures[index]}
              number={figure.number}
              prefix={figure.prefix}
              suffix={figure.suffix}
              color={figure.color}
              text={figure.text}
              textColor={this.props.textColor}
              play={this.props.play}
              dots={this.props.dots}
            />
          </li>
        ))}
      </ul>
    );
  }
}

FiguresTable.propTypes = {
  columns: PropTypes.oneOf([2, 3]),
  figures: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      number: PropTypes.number.isRequired,
      prefix: PropTypes.string,
      suffix: PropTypes.string,
      color: PropTypes.string.isRequired,
      text: PropTypes.string,
    })
  ).isRequired,
  textColor: PropTypes.string,
  play: PropTypes.bool,
  dots: PropTypes.bool,
};

export default FiguresTable;
